// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BMah","buttons":"styles_buttons__3C8HG"};